import { initializeApp } from "firebase/app";
import { createUserWithEmailAndPassword, getAuth, onAuthStateChanged, reauthenticateWithCredential, sendPasswordResetEmail, signInWithEmailAndPassword, signOut, updatePassword, User } from "firebase/auth";
import { EmailAuthProvider } from "firebase/auth/web-extension";
import { getFirestore } from "firebase/firestore";

export class FirebaseService {

    firebaseConfig = {
        apiKey: "AIzaSyACKSARE1YCHqF6ENhl443nuC27_9lwcbY",
        authDomain: "ecoconduite-ab3c1.firebaseapp.com",
        projectId: "ecoconduite-ab3c1",
        storageBucket: "ecoconduite-ab3c1.appspot.com",
        messagingSenderId: "427073805176",
        appId: "1:427073805176:web:12cdd81938610f46e8868d",
        measurementId: "G-MBM5ZSBFH2"
    };

    app = initializeApp(this.firebaseConfig);

    // Initialisation des services
    auth = getAuth(this.app);
    db = getFirestore(this.app);

    constructor() {
    }


    async getUserIdToken() {
        await this.waitForAuth();
        const user = this.auth.currentUser;
        if (!user) {
            return null;
        }

        return await user.getIdToken();
    }

    async getUserEmail() {
        await this.waitForAuth()
        const user = this.auth.currentUser;
        if (!user) {
            return null;
        }

        return await user.email;
    }

    async getUser() {
        await this.waitForAuth();
        return this.auth.currentUser;
    }

    async loginWithEmail(email: string, password: string) {
        return await signInWithEmailAndPassword(this.auth, email, password);
    }

    async lostPassword(email: string) {
        return await sendPasswordResetEmail(this.auth, email);
    }

    async changePassword(oldpassword: string, password: string) {
        let email = await this.getUserEmail();
        if (!email) return null;
        let user = await this.getUser()
        if (user != null) {
            try {
                const credential = EmailAuthProvider.credential(email, oldpassword);
                await reauthenticateWithCredential(user, credential);
            }
            catch (e: any) {
                console.log(e)
                return null;
            }

            user = await this.getUser()
            if (user) {
                try {
                    await updatePassword(user, password)
                    return true;
                }
                catch (e: any) {
                    return null;
                }
            }

        }
        return null;
    }

    async createAccount(email: string, password: string) {
        return await createUserWithEmailAndPassword(this.auth, email, password);
    }

    async logout() {
        return await signOut(this.auth);
    }

    async waitForAuth(): Promise<User | null> {
        return new Promise((resolve) => {
            const unsubscribe = onAuthStateChanged(this.auth, (user) => {
                unsubscribe(); // important: ne déclenche qu’une fois
                resolve(user);
            });
        });
    }
}